import styled, { DefaultTheme, css } from "styled-components";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

export const Container = styled.div`
  .ant-picker-suffix {
    position: absolute;
    margin: unset;
    transform: translateY(-1px);
  }

  .ant-picker-disabled {
    background-color: ${({ theme }) => theme?.colors?.neutral.neutral30};
    border: ${({ theme }) => theme?.colors?.gray.gray10};
    color: ${({ theme }) => theme?.colors?.typography.disabled2};
  }

  .ant-picker-input {
    &:hover {
      .ant-picker-clear {
        right: 0;
        left: unset;
      }
    }
  }

  .ant-picker-input > input {
    margin-left: 28px;
    font-size: 14px;
    font-weight: 400;
    font-family: Nunito-Sans;
    color: ${({
      // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Omit<D... Remove this comment to see the full error message
      disabled,
      theme,
    }) => (disabled ? theme?.colors?.typography.disabled2 : theme?.colors?.neutral.neutral90)};
  }

  .ant-picker:hover,
  .ant-picker-focused {
    outline: none;
    border: ${({
      // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Omit<D... Remove this comment to see the full error message
      disabled,
      theme,
    }) => (disabled ? "none" : `2px solid ${theme?.colors?.primary.tint2} !important`)};
    box-shadow: unset;
  }
`;

const datePickerStyle = ({ error, theme }: { error: boolean; theme: DefaultTheme }) => css`
  width: 100%;
  height: 40px;
  border-radius: 10px;
  border: 2px solid ${error ? theme?.colors?.dangerv2.border : theme?.colors?.neutral.neutral30};
  margin-top: 15px;
`;

export const Date = styled(DatePicker)`
  ${datePickerStyle}
`;

export const Range = styled(RangePicker)`
  ${datePickerStyle}
`;

export const Label = styled.div`
  font-family: Nunito-Sans-Light;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme?.colors?.neutral.neutral90};
`;

export const ErrorMessage = styled.div`
  font-family: Nunito-Sans-SemiBold;
  font-size: 12px;
  margin-top: 2px;
  color: ${({ theme }) => theme?.colors?.dangerv2.default};
  float: ${({
    // @ts-expect-error TS(2339): Property 'errorPosition' does not exist on type 'O... Remove this comment to see the full error message
    errorPosition,
  }) => errorPosition};
`;
